import script from "./FeedbackCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackCarousel.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackCarousel.vue?vue&type=style&index=0&id=798f8f0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-798f8f0c"]])

export default __exports__